import { render, staticRenderFns } from "./CargoPrintCN.vue?vue&type=template&id=085ec1f9&"
import script from "./CargoPrintCN.vue?vue&type=script&lang=js&"
export * from "./CargoPrintCN.vue?vue&type=script&lang=js&"
import style0 from "./CargoPrintCN.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CargoPrintCN.vue"
export default component.exports